import {panelViews} from '../../PanelBank/types';
import {type MediaBrowserPanelConfig} from '../common';

export const keysToTitle = (keys: string[]) => {
  return keys.length < 2 ? keys[0] : keys.join(', ');
};

export function getTitleFromConfig(config: MediaBrowserPanelConfig): string {
  return (
    config.chartTitle ||
    (config.mediaKeys != null
      ? keysToTitle(config.mediaKeys)
      : panelViews.mediaBrowser)
  );
}
